// =============================================================================
// BACKGROUND — Animierter Hintergrund
// -----------------------------------------------------------------------------
// Aufbau (von hinten nach vorn):
//   1. Cyan + Roter Glow-Kreis (schwebende Lichtblasen)
//   2. Karo-Raster (driftet langsam)
//   3. Schwebende Partikel (PARTICLE_COUNT aus config.js)
//   4. Scanlines (TV-Effekt)
//   5. Noise-Grain (subtile Körnung)
// Alle Stile sind in App.css unter "BACKGROUND" definiert.
// =============================================================================

import { useMemo } from "react";
import { PARTICLE_COUNT } from "@/config";

function Particles() {
  // useMemo: Partikel-Daten nur einmal pro Mount berechnen
  const items = useMemo(() => {
    return Array.from({ length: PARTICLE_COUNT }).map((_, i) => {
      const left = Math.random() * 100;               // horizontale Startposition
      const size = 2 + Math.random() * 3;             // 2–5 px
      const duration = 12 + Math.random() * 18;       // Aufstiegsdauer in Sek.
      const delay = -Math.random() * 25;              // negative Verzögerung -> direkter Start
      const drift = (Math.random() * 80 - 40) + "px"; // seitliches Driften
      const isRed = Math.random() > 0.7;              // ~30% rote Partikel
      return { i, left, size, duration, delay, drift, isRed };
    });
  }, []);

  return items.map((p) => (
    <span
      key={p.i}
      className={`particle ${p.isRed ? "red" : ""}`}
      style={{
        left: `${p.left}%`,
        bottom: "-10px",
        width: `${p.size}px`,
        height: `${p.size}px`,
        animationDuration: `${p.duration}s`,
        animationDelay: `${p.delay}s`,
        "--drift": p.drift,
      }}
    />
  ));
}

export default function Background() {
  return (
    <div className="bg-stage" aria-hidden="true">
      <div className="bg-glow-a" />
      <div className="bg-glow-b" />
      <div className="bg-grid" />
      <Particles />
      <div className="bg-scan" />
      <div className="bg-noise" />
    </div>
  );
}
